import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

import villageRouter from './modules/village'
import recruitment from './modules/recruitment'
import partymember from './modules/partymember'
import wangge from './modules/wangge'
import pension from './modules/pension'
import guanghe from './modules/guanghe'
import fangyi from './modules/fangyi'
import huayang from './modules/huayang'
import zhengxie from './modules/zhengxie'
import oldman from './modules/oldman'
import anLuoYun from './modules/anLuoYun'
import Lycal from './modules/Lycal'
import ylOrder from './modules/ylOrder'
import fivestar from './modules/fivestar'
import neighbor from './modules/neighbor'
import hotel from './modules/hotel'

/* Layout */
import Layout from '@/layout'


const router = new Router({
  routes: [
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: '',
          name: 'Home',
          meta: {
            title: '掌上河阳',
          },
          component: () => import('@/views/home/index.vue'),
        },
      ],
    },
    {
      path: '/test',
      component: Layout,
      children: [
        {
          path: '',
          meta: {
            title: '测试list',
          },
          component: () => import('@/views/list.vue'),
        },
      ],
    },
    // 网上办事
    {
      path: '/work',
      component: Layout,
      children: [
        {
          name: 'WorkGroup',
          path: '',
          component: () => import('@/views/work/group.vue'),
        },
        {
          name: 'Work',
          path: ':nwkId',
          component: () => import('@/views/work/index.vue'),
        },
        {
          name: 'WorkApply',
          path: 'apply/:NWMId/:WorkKind',
          component: () => import('@/views/work/apply/index.vue'),
        },
      ],
    },
    // 工作动态
    {
      path: '/activity',
      component: Layout,
      children: [
        {
          path: '',
          meta: {
            title: '工作动态',
          },
          component: () => import('@/views/activity/index.vue'),
        },
        {
          path: 'detail/:Id',
          meta: {
            title: '详情',
          },
          component: () => import('@/views/activity/detail.vue'),
        },
        {
          path: 'addActivity',
          meta: {
            title: '发布工作动态',
          },
          component: () => import('@/views/activity/addActivity.vue'),
        },
      ],
    },
    // 居民来稿
    {
      path: '/submissions',
      component: Layout,
      children: [
        {
          path: '',
          meta: {
            title: '居民来稿',
          },
          component: () => import('@/views/submissions/index.vue'),
        },
        {
          path: 'detail/:Id',
          meta: {
            title: '详情',
          },
          component: () => import('@/views/submissions/detail.vue'),
        },
        {
          path: 'addActivity',
          meta: {
            title: '投稿',
          },
          component: () => import('@/views/submissions/addActivity.vue'),
        },

      ],
    },
    // 志愿者活动
    {
      path: '/volunteerAct',
      component: Layout,
      children: [
        {
          path: '',
          meta: {
            title: '志愿者活动',
          },
          component: () => import('@/views/volunteerAct/index.vue'),
        },
        {
          path: 'detail/:Id',
          meta: {
            title: '志愿者活动',
          },
          component: () => import('@/views/volunteerAct/detail.vue'),
        },
      ],
    },
    // 我的活动记录
    {
      path: '/activityLog',
      component: Layout,
      children: [
        {
          path: '',
          meta: {
            title: '我的活动记录',
          },
          component: () => import('@/views/activityLog/index.vue'),
        },
        {
          path: 'detail/:Id/:paId',
          meta: {
            title: '我的活动记录',
          },
          component: () => import('@/views/activityLog/detail.vue'),
        },
        {
          path: '/detail/recActLogs/:Id',
          meta: {
            title: '心得体会',
          },
          component: () => import('@/views/activityLog/recActLogs.vue'),
        },
      ],
    },
    // 资讯中心
    {
      path: '/article',
      component: Layout,
      children: [
        {
          path: '',
          meta: {
            title: '活动通告',
          },
          component: () => import('@/views/article/index.vue'),
        },
        {
          path: 'detail/:Id',
          meta: {
            title: '详情',
          },
          component: () => import('@/views/article/detail.vue'),
        },
        {
          path: 'addActivity',
          meta: {
            title: '发布活动通告',
          },
          component: () => import('@/views/article/addActivity.vue'),
        },
      ],
    },
    // 工作简报
    {
      path: '/working',
      component: Layout,
      children: [
        {
          path: '',
          meta: {
            title: '管家风采',
          },
          component: () => import('@/views/working/index.vue'),
        },
        {
          path: 'detail/:Id',
          meta: {
            title: '详情',
          },
          component: () => import('@/views/working/detail.vue'),
        },
      ],
    },
      // 工作简报
      {
        path: '/governmentAffairs',
        component: Layout,
        children: [
          {
            path: '',
            meta: {
              title: '政务发布',
            },
            component: () => import('@/views/governmentAffairs/index.vue'),
          },
          {
            path: 'detail/:Id',
            meta: {
              title: '详情',
            },
            component: () => import('@/views/governmentAffairs/detail.vue'),
          },
        ],
      },
      // 发布任务
      {
        path: '/task',
        component: Layout,
        children: [
          {
            path: '',
            meta: {
              title: '任务发布',
            },
            component: () => import('@/views/task/addTask.vue'),
          },
        ],
      },
    // 便民资讯
    {
      path: '/trealinfo',
      component: Layout,
      children: [
        {
          path: 'detail/:Id',
          meta: {
            title: '便民资讯',
          },
          component: () => import('@/views/trealinfo/detail.vue'),
        },
      ],
    },
    // 社区风采
    {
      path: '/scenery',
      component: Layout,
      children: [
        {
          path: '',
          meta: {
            title: '活动风采',
          },
          component: () => import('@/views/scenery/index.vue'),
        },
        {
          path: 'detail/:Id',
          meta: {
            title: '详情',
          },
          component: () => import('@/views/scenery/detail.vue'),
        },
        {
          path: 'addActivity',
          meta: {
            title: '发布活动风采',
          },
          component: () => import('@/views/scenery/addActivity.vue'),
        },
      ],
    },
    // 便民商店
    {
      path: '/shop',
      component: Layout,
      children: [
        {
          path: '',
          meta: {
            title: '惠民活动',
          },
          component: () => import('@/views/shop/index.vue'),
        },
        {
          path: '/shop/detail',
          meta: {
            title: '活动详情',
          },
          component: () => import('@/views/shop/detail.vue'),
        },
        {
          path: '/shop/type',
          meta: {
            title: '活动分类',
          },
          component: () => import('@/views/shop/type.vue'),
        },
        {
          path: '/shop/PromotionType',
          meta: {
            title: '活动分类',
          },
          component: () => import('@/views/shop/PromotionType.vue'),
        },
        {
          path: '/shop/list',
          meta: {
            title: '商城列表',
          },
          component: () => import('@/views/shop/list.vue'),
        },
        {
          path: '/shop/orderDetail',
          meta: {
            title: '订单详情',
          },
          component: () => import('@/views/shop/orderDetail.vue'),
        },
        {
          path: '/personal',
          meta: {
            title: '个人中心',
          },
          component: () => import('@/views/shop/personal.vue'),
        },
        {
          path: '/shop/PromotionXq/:Id',
          meta: {
            title: '活动详情',
          },
          component: () => import('@/views/shop/PromotionXq.vue'),
        },
        {
          path: '/shop/PromotionList',
          meta: {
            title: '促销活动列表',
          },
          component: () => import('@/views/shop/PromotionList.vue'),
        },
        {
          path: '/PromotionBm',
          meta: {
            title: '报名信息',
          },
          component: () => import('@/views/shop/PromotionBm.vue'),
        },
        {
          path: '/shop/myPromotion',
          meta: {
            title: '我的报名',
          },
          component: () => import('@/views/shop/myPromotion.vue'),
        },
      ],
    },
    // 通知公告
    {
      path: '/articleList',
      component: Layout,
      children: [
        {
          path: '',
          meta: {
            title: '通知公告',
          },
          component: () => import('@/views/article/articleList.vue'),
        },
      ],
    },

    // 个人中心
    {
      path: '/center',
      component: Layout,
      children: [
        {
          path: '',
          component: () => import('@/views/center/index.vue'),
        },
      ],
    },
    // 通知公告
    {
      path: '/notice',
      component: Layout,
      children: [
        {
          path: '',
          meta: {
            title: '通知公告',
          },
          component: () => import('@/views/notice/index.vue'),
        },
        {
          path: '/notice/detail/:Id',
          meta: {
            title: '通知公告',
          },
          component: () => import('@/views/notice/detail.vue'),
        },

      ],
    },
    // 会员注册
    {
      path: '/member',
      component: Layout,
      children: [
        {
          path: '',
          meta: {
            title: '会员注册',
          },
          component: () => import('@/views/member/index.vue'),
        },
      ],
    },
    {
      path: '/memberUpdata',
      component: Layout,
      children: [
        {
          path: '',
          meta: {
            title: '修改会员信息',
          },
          component: () => import('@/views/member/memberUpdata.vue'),
        },
      ],
    },
    // 走访巡街
    {
      path: '/watchman',
      component: Layout,
      children: [
        {
          path: '',
          meta: {
            title: '走访巡街',
          },
          component: () => import('@/views/watchman/index.vue'),
        },
        {
          path: '/watchman/trajectory/:Id',
          name: 'trajectory',
          meta: {
            title: '走访巡街',
          },
          component: () => import('@/views/watchman/trajectory.vue'),
        },
        {
          path: '/trajectoryMap',
          meta: {
            title: '走访巡街',
          },
          component: () => import('@/views/watchman/trajectoryMap.vue'),
        },
      ],
    },
    // 积分商城
    {
      path: '/integral',
      component: Layout,
      children: [
        {
          path: '',
          meta: {
            title: '积分商城',
          },
          component: () => import('@/views/integral/index.vue'),
        },
        {
          path: '/integral/detail/:Id',
          meta: {
            title: '商品详情',
          },
          component: () => import('@/views/integral/detail.vue'),
        },
      ],
    },
    // 邻里中心
    {
      path: '/neighbor',
      component: Layout,
      children: [
        {
          path: '',
          meta: {
            title: '邻里中心',
          },
          component: () => import('@/views/neighbor/index.vue'),
        },
        {
          path: '/huayang/comment/:id',
          meta: {
            title: '积分商城',
          },
          component: () => import('@/views/neighbor/comment.vue'),
        },
        {
          path: '/shop/myShop/myShopOrder',
          name: 'myShop',
          meta: {
            title: '我的订单',
          },
          component: () => import('@/views/shop/myShopOrder/index.vue'),
        },
        {
          path: '/neighbor/FnRoom/:id',
          meta: {
            title: '便民服务',
          },
          component: () => import('@/views/neighbor/FnRoom.vue'),
        },
        {
          path: '/huayang/comment/:id',
          name: 'comment',
          meta: {
            title: '服务评价',
          },
          component: () => import('@/views/neighbor/comment.vue'),
        },
        {
          path: '/neighbor/firmlogin/:id',
          meta: {
            title: '便民食堂',
          },
          component: () => import('@/views/neighbor/firmlogin.vue'),
        },
        {
          path: '/neighbor/firmlogin/foodDetail/:Id',
          meta: {
            title: '美食详情',
          },
          component: () => import('@/views/neighbor/foodDetail.vue'),
        },
        {
          path: '/guanghe/evaluating/:id',
          meta: {
            title: '闲置资产出租',
          },
          component: () => import('@/views/guanghe/evaluating.vue'),
        },
        {
          path: '/neighbor/goodList/:RoomId',
          meta: {
            title: '食堂详情',
          },
          component: () => import('@/views/neighbor/goodList.vue'),
        },
        {
          path: '/intrgralShop/:totalIntegral',
          meta: {
            title: '积分商城',
          },
          component: () => import('@/views/intrgralShop/index.vue'),
        },

      ],
    },
    // 问卷调查
    {
      path: '/questionnaire/:id',
      meta: {
        title: "登记"
      },
      component: () => import('@/views/Questionnaire/Questionnaire.vue'),
    },
     // 长安路智慧社区
     {
      path: '/Changan-zhsq/NewsArticles',
      component: Layout,
      children: [
        {
          path: '',
          meta: {
            title: '资讯',
          },
          component: () => import('@/views/Changan-zhsq/NewsArticles/index.vue'),
        },
        {
          path: 'merchantAdvertising/:Id',
          meta: {
            title: '广告',
          },
          component: () => import('@/views/Changan-zhsq/NewsArticles/merchantAdvertising.vue'),
        },
        {
          path: 'merchantAdvertisingDetail/:Id',
          meta: {
            title: '广告详情',
          },
          component: () => import('@/views/Changan-zhsq/NewsArticles/merchantAdvertisingDetail.vue'),
        },
        {
          path: 'merchantDetail/:Id/:type',
          meta: {
            title: '详情',
          },
          component: () => import('@/views/Changan-zhsq/NewsArticles/merchantDetail.vue'),
        },
        {
          path: 'detail/:Id',
          meta: {
            title: '详情',
          },
          component: () => import('@/views/Changan-zhsq/NewsArticles/detail.vue'),
        },
        {
          path: 'addActivity',
          meta: {
            title: '发布资讯',
          },
          component: () => import('@/views/Changan-zhsq/NewsArticles/addActivity.vue'),
        },
         {
          path: 'AddbusinessInfo',
          meta: {
            title: '发布业务提醒',
          },
          component: () => import('@/views/Changan-zhsq/NewsArticles/AddbusinessInfo.vue'),
        },
          {
          path: 'addAlert',
          meta: {
            title: '发布警情',
          },
          component: () => import('@/views/Changan-zhsq/NewsArticles/addAlert.vue'),
        },
          {
          path: 'addzoneCommunityPosts',
          meta: {
            title: '发布园社联建',
          },
          component: () => import('@/views/Changan-zhsq/NewsArticles/addzoneCommunityPosts.vue'),
        },
        
      ],
      
    },
    // 房屋出租 src\views\Changan-zhsq\tenement\evaluating.vue
    {
      path: '/Changan-zhsq/tenement',
      component: Layout,
      children: [
        {
          path: '',
          meta: {
            title: '租房信息交流',
          },
          component: () => import('@/views/Changan-zhsq/tenement/evaluating.vue'),
        },
        {
          path: 'addXianzhi/:id/:openId',
          meta: {
            title: '我有房新增',
          },
          component: () => import('@/views/Changan-zhsq/tenement/addXianzhi.vue'),
        },
        {
          path: 'addlessee/:id/:openId',
          meta: {
            title: '我要租新增',
          },
          component: () => import('@/views/Changan-zhsq/tenement/addlessee.vue'),
        },
        {
          path: 'lesseeDetails/:Id/:type',
          meta: {
            title: '我要租详情',
          },
          component: () => import('@/views/Changan-zhsq/tenement/lesseeDetails.vue'),
        },
        {
          path: 'details/:Id',
          meta: {
            title: '我有房详情',
          },
          component: () => import('@/views/Changan-zhsq/tenement/details.vue'),
        },
        {
          path: 'merchantDeatil/:id',
          meta: {
            title: '详情',
          },
          component: () => import('@/views/Changan-zhsq/employment/merchantDeatil.vue'),
        },
        // {
        //   path: 'index',
        //   name: 'index',
        //   meta: {
        //     title: "服务详情"
        //   },
        //   component: () => import('@/views/Changan-zhsq/tenement/index.vue')
        // },
      ],
    },

    {
      path: '/Changan-zhsq/employment',
      component: Layout,
      children: [
        {
          path: 'addEmployment/:id',
          meta: {
            title: '新增求职',
          },
          component: () => import('@/views/Changan-zhsq/employment/addEmployment.vue'),
        },
        {
          path: 'detail/:id',
          meta: {
            title: '详情',
          },
          component: () => import('@/views/Changan-zhsq/employment/detail.vue'),
        },
        // {
        //   path: 'index',
        //   name: 'index',
        //   meta: {
        //     title: "服务详情"
        //   },
        //   component: () => import('@/views/Changan-zhsq/tenement/index.vue')
        // },
      ],
    },
    {
      path: '/Changan-zhsq/ResidentsHelp',
      component: Layout,
      children: [
        {
          path: 'addResidentsHelp/:id',
          meta: {
            title: '新增居民互助',
          },
          component: () => import('@/views/Changan-zhsq/ResidentsHelp/addResidentsHelp.vue'),
        },
        {
          path: 'detail/:id',
          meta: {
            title: '居民互助详情',
          },
          component: () => import('@/views/Changan-zhsq/ResidentsHelp/detail.vue'),
        },
        // {
        //   path: 'index',
        //   name: 'index',
        //   meta: {
        //     title: "服务详情"
        //   },
        //   component: () => import('@/views/Changan-zhsq/tenement/index.vue')
        // },
      ],
    },
    {
      path: '/Changan-zhsq/sharedSpace',
      component: Layout,
      children: [
        {
          path: 'details/:openId/:id',
          meta: {
            title: '场所详情',
          },
          component: () => import('@/views/Changan-zhsq/sharedSpace/details.vue'),
        },
      ],
    },
    villageRouter,
    recruitment,
    partymember,
    wangge,
    pension,
    guanghe,
    fangyi,
    huayang,
    zhengxie,
    oldman,
    anLuoYun,
    Lycal,
    ylOrder,
    fivestar,
    neighbor,
    hotel,
  ],
})

// 动画效果
router.beforeEach((to, from, next) => {
  console.log(to.path)
  console.log(from.path)

  if (to.meta.title) {
    document.title = to.meta.title
  }

  if (
    to.path == from.path ||
    ((to.path == '/' || to.path == '/serve' || to.path == '/center') &&
      (from.path == '/' ||
        from.path == '/serve' ||
        from.path == '/login' ||
        from.path == '/village'))
  ) {
    store.commit('UPDATE_DIRECTION', 'none')
  } else if (
    to.path.indexOf(from.path) != -1 ||
    (from.name && to.name.indexOf(from.name) != -1)
  ) {
    store.commit('UPDATE_DIRECTION', 'forward')
  } else {
    store.commit('UPDATE_DIRECTION', 'reverse')
  }
  next()
})

export default router
